import React, { Component } from 'react';
// import logo from '../../../assets/image/logo.png';
// import Button from '../../shared/button/button';
// import { company } from '../../../constant/global.constant';
// import { path } from '../../../config/routes.config';
// import './conditionPage.scss';
// import Checkbox from '../../shared/checkbox/checkbox';
import Swal from 'sweetalert2';
import axios from 'axios';
import '../css/conditionPage.scss';
// import { _post, _Alert } from './Function';
// import { routes } from '../../../config/routes.config';
// import SwalData from '../../shared/SwalData/swaldata';
import Modal from '../component/Modal';
import { _post, _Alert, _setTime, _timeOut, variable, _isLoginPage, _infoAlert } from './Function';

class ConditionPage extends Component {
    state = {
        dataSet: '',
        term_id: '',
        term_type: '',
        term_version:''

    }
    

    constructor(props) {
        super(props);
        this.conditionDetail()
    }

    online = () => {
        console.log("dasboard onCondition >>>>>>>>>>>>>>>>>> ",this.state.isChecked)
        
        // this.
        if(this.state.isChecked == true){        
            axios.post(`https://www.srusct.or.th/APIs/apporve_condition.php`, { member_no : localStorage.getItem("member_no"),term_type:this.state.term_type,term_id:this.state.term_id,term_version:this.state.term_version })
            .then( res => {
                console.log(res)
                localStorage.setItem("isCheck","true")
                if(this.props.onCondition == 'register'){
                    // window.location.href = path+'/register';
                    window.location.href = '/online/register'
                }else{
            console.log("dasboard onCondition")
            window.location.href = '/online/dashboard';
                // window.location.href = routes.dashboard;
                // if (this.props.isAuthenWithLogin !== prevProps.isAuthenWithLogin && this.props.isAuthenWithLogin) {
                    // window.location.href = routes.login;
                // }
                }
              // console.log(res.data.condition[0].condition_detail);
              // this.setState({detail:res.data.condition[0].condition_detail})
            })   
        }else{
            // return
            alert('กรุณาเช็คยอมรับเงื่อนไข ก่อนกดปุ่มยอมรับ หรือ ติดต่อเจ้าหน้าที่') 
        }
        // <Link className="link l-l" to={routes.register}>{loginConstant.registerText}</Link>
    }

    handleCloseModal = () => {
        this.setState({ isOpen: false });
      };



    checkApporve(){}

  async  handleChange(e) {
    this.setState({ isOpen: true });
        let isChecked = e.target.checked;
        console.log(isChecked)
        await this.setState({ isChecked: isChecked });
        
        // if(this.state.isChecked == true){
        //     alert("yes")
        // }else{
            
        //     return (
        //     <Modal title="hi"  openModal={true} closeModal={this.closeModal}>
        //     </Modal>
        //     );
        // }
      }

      componentDidMount() {
          console.log("POST")
        axios.post(`https://www.srusct.or.th/APIs/condition.list.php`, {  })
      .then(res => {
        console.log(res);
        console.log(res.data.condition[0].condition_detail);
        this.setState({detail:res.data.condition[0].condition_detail})
        this.setState({term_id:res.data.condition[0].term_id})
        this.setState({term_type:res.data.condition[0].term_type})
        this.setState({term_version:res.data.condition[0].term_version})
        // 
      })
      }

      conditionDetail(){
        return (
            <div className="text-align-center">
                <div className="row">
                    <div className="profile-button">ยืนยันการเข้าใช้บริการ</div>
                    </div>
             </div>       
                    )
        //   this.props.onCondition();
        // const data = `<h2>Title</h2>
        // <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p>
        // <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p>
        // <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p>
        // <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p>`;
        // localStorage.setItem("data",data)
        // this.setState({dataSet:data})
        // return
        // document.getElementById('error-message').innerHTML = "<span class='error'>my error</span>";
      }  
    // updatemember = (e) => !isNaN(e.target.value) && this.setState({ checked: e.target.value });

    closeModal = () => false;

    render() {
        console.log(this.state)
        console.log(this.props)
        const dataDetail = this.state.detail
        // const handleClose = () => setShow(false);
        // onCondition
        
        // this.conditionDetail()
        return (
            <div className="pageNotFound-container">
                <div className="content">
                    <div>
                        <div className="logo">
                            {/* <img src={logo} /> */}
                            <div className="title">เงื่อนไขการให้บริการ</div>
                        </div>
                    </div>
                    <div class="section" dangerouslySetInnerHTML={{ __html: dataDetail }} >
                    {/* <div dangerouslySetInnerHTML={{ __html: dataDetail }} /> */}
                    {/* <h2>Title</h2>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Perspiciatis non, inventore incidunt repudiandae id vel nisi officiis provident iste necessitatibus. Ex recusandae eveniet tempora.</p> */}
                    </div>
                   <div>
                       {/* <Checkbox onChange={this.handleChange} /> */}
                       <div className="topping">
                       <input type="checkbox" id="approve" name="approve" onChange={e => this.handleChange(e)}/><span className='setPosition'>ฉันได้อ่าน ทำความเข้าใจ และยอมรับเงื่อนไข</span>
                    </div>
                   </div>
                    <div className="button">
                        {/* <Button text={'ยอมรับ'} action={() => this.online()} /> */}
                        {/* <SwalData text={'ยอมรับ'} action={() => this.online()} /> */}
                        {<button type="button" className="btn btn-light btn-lg btnsetB" onClick={(e) => this.online()}>ยอมรับ</button>}
                      
        
                    </div>
                </div>
            </div>
        );
    }
}




export default ConditionPage;